/**
 * customsirge_review_dedupe.js — hides a Judge.me review title that only repeats the review.
 *
 * When a reviewer leaves no title, Judge.me uses the opening words of the review as the title, so
 * the card shows the same sentence twice ("I don't like the way the bar is on my hands this" over
 * "I don't like the way the bar is on my hands this I see a perfect snug fit"). Client, 2026-10-22.
 * A title is hidden only when the body STARTS with it (case, punctuation, emoji and a trailing
 * ellipsis ignored); a real title is never touched. Judge.me renders late and re-renders on paging,
 * so a MutationObserver re-checks new cards.
 */
(function () {
  'use strict';
  var PAIRS = [
    ['.jdgm-carousel-item__review-title', '.jdgm-carousel-item__review-body'],
    ['.jdgm-rev__title', '.jdgm-rev__body'],
    ['.jdgm-rev-widg__title', '.jdgm-rev-widg__body']
  ];
  function norm(t) {
    return (t || '').toLowerCase().replace(/(…|\.\.\.)\s*$/, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function check(root) {
    PAIRS.forEach(function (pair) {
      (root.querySelectorAll ? root.querySelectorAll(pair[0]) : []).forEach(function (title) {
        if (title.dataset.csDedupe) return;
        var scope = title.parentElement, body = scope && scope.querySelector(pair[1]);
        while (scope && !body && scope !== document.body) { scope = scope.parentElement; body = scope && scope.querySelector(pair[1]); }
        if (!body) return;
        title.dataset.csDedupe = '1';
        var t = norm(title.textContent), b = norm(body.textContent);
        if (t && b.indexOf(t) === 0) title.style.display = 'none';
      });
    });
  }
  function start() {
    check(document);
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; check(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
